<template>
  <sdCards headless>
    <div class="author-info">
      <figcaption>
        <div class="info">
          <sdHeading as="h4">{{ user_info.name }} {{ user_info.surname }}</sdHeading>
          <p>
            <b>{{ user_info.invoice_company_name }}</b>
          </p>
          <br />
          <p>Genel Komisyon Oranı: %{{ user_info.commission_rate }}</p>
        </div>
      </figcaption>
    </div>
    <nav class="settings-menmulist">
      <ul>
        <li>
          <router-link :to="{ name: 'set-profile' }">
            <sdFeatherIcons type="user" size="14" />
            {{ $t('pages.settings.my-profile') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'set-invoice' }">
            <sdFeatherIcons type="user" size="14" />
            {{ $t('pages.settings.billling-information') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'set-account' }">
            <sdFeatherIcons type="settings" size="14" />
            {{ $t('pages.settings.account-settings') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'set-password' }">
            <sdFeatherIcons type="key" size="14" />
            {{ $t('pages.settings.change-password') }}
          </router-link>
        </li>
      </ul>
    </nav>
  </sdCards>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AuthorBox',
  components: {},
  computed: {
    ...mapGetters({
      user_info: 'setting/user_info',
    }),
  },
};
</script>
